module.exports = __webpack_public_path__ + "img/icon_clock.73a7ef99.svg";